import { render, staticRenderFns } from "./MBatchBuilder.vue?vue&type=template&id=63d3a4ac&scoped=true&lang=pug&"
import script from "./MBatchBuilder.vue?vue&type=script&lang=ts&"
export * from "./MBatchBuilder.vue?vue&type=script&lang=ts&"
import style0 from "./MBatchBuilder.vue?vue&type=style&index=0&id=63d3a4ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d3a4ac",
  null
  
)

export default component.exports